import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Hash destinations can move while a route loads its catalog or web fonts.
// Follow those brief layout changes, but stop as soon as the visitor acts.
export default function useRouteScroll() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: "instant" });
      return;
    }
    let id = hash.slice(1);
    try { id = decodeURIComponent(id); } catch { /* retain literal ID */ }
    let stopped = false;
    let frame;
    const align = () => {
      if (stopped) return;
      const target = document.getElementById(id);
      if (target) {
        const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - 96);
        window.scrollTo({ top, behavior: "instant" });
      }
    };
    const queue = () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(align);
    };
    const observer = new ResizeObserver(queue);
    const stop = () => {
      stopped = true;
      observer.disconnect();
      window.cancelAnimationFrame(frame);
    };
    observer.observe(document.body);
    queue();
    const timer = window.setTimeout(stop, 1500);
    const events = ["pointerdown", "wheel", "touchstart", "keydown"];
    events.forEach(event => window.addEventListener(event, stop, { passive: true }));
    return () => {
      stop();
      window.clearTimeout(timer);
      events.forEach(event => window.removeEventListener(event, stop));
    };
  }, [pathname, hash]);
}
